import React from 'react';
import './Footer.css'


function Footer() {
  return (
    <footer className="footer">
      <span>Joseph J Lyons 2021</span>
    </footer>
  );
}

export default Footer;